import React from 'react'
import styled from '@emotion/styled'
import { colors, mediaQueriesByDevice } from 'parameters/index'
import { Trivia } from 'generated/api'
import { TitleSkeleton } from 'components/patterns/Skeleton'
import { ID } from 'lib'
import { Pending } from 'components/patterns/suspense/internals/types'

interface Props {
	trivia: Trivia
}

export const TriviaItem: React.FC<React.PropsWithChildren<Pending<Props>>> = props => {
	let value, title, key
	if (props.pending) {
		key = ID()
		title = <TitleSkeleton />
		value = <TitleSkeleton size="large" />
	} else {
		const { trivia } = props
		key = trivia.key
		value = trivia.value
		title = trivia.title
	}

	return (
		<TriviaItemWrapper key={key}>
			<TriviaItemTitle>{title}</TriviaItemTitle>
			<TriviaItemValue>{value}</TriviaItemValue>
		</TriviaItemWrapper>
	)
}

export const FlexGroup = styled.div`
	display: flex;

	${mediaQueriesByDevice.tablet} {
		padding: 0 20px;
		width: 100%;

		a,
		button {
			width: 100%;
		}
	}
`

export const GrowingFlexGroup = styled(FlexGroup)`
	flex: 2 1 auto;
`

const TriviaItemWrapper = styled.div`
	display: flex;
	flex: 1 1 auto;
	flex-direction: column;
	justify-content: center;
`

const TriviaItemValue = styled.div`
	font-weight: 700;
	font-size: 20px;
	line-height: 100%;

	${mediaQueriesByDevice.mobilePortrait} {
		font-size: 14px;
	}
`

const TriviaItemTitle = styled.div`
	font-size: 14px;
	line-height: 100%;
	color: ${colors.primaryDarkGrey1};
	margin-bottom: 4px;
`
